// extracted by mini-css-extract-plugin
export default {"wrapper":"MainPage_wrapper__0KL4v","main":"MainPage_main__YC0-t"};